import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';

export const useQuoteRestrictionsMessageStyles = createStyles(({ token }) => ({
  quotesNotification: {
    '&& .ant-message-notice-content': {
      boxShadow: `0 0 40px ${ThemeColors.COLOR_GREY7_5}`,

      '.ant-message-custom-content': {
        paddingRight: 14,
      },

      '.anticon-exclamation-circle': {
        paddingTop: 14,
        alignSelf: 'flex-start',
        marginRight: 0,
      },
    },
  },
  quotesNotificationContent: {
    color: ThemeColors.COLOR_BLACK,
    fontWeight: 500,
    height: 'auto',
    paddingBottom: ThemeSpaces.SPACE_NORM,
    paddingRight: ThemeSpaces.SPACE_NORM,
    paddingTop: ThemeSpaces.SPACE_NORM,
    textAlign: 'center',
    textWrap: 'wrap',

    '> a': {
      marginLeft: token.marginXXS,
    },
  },
  newQuoteNotificationHeader: {
    fontFamily: token.fontFamily,
    textAlign: 'left',
    fontSize: token.fontSizeLG,
  },
  quoteDisclaimerNotification: {
    textAlign: 'left',
    width: 290,
  },
  quoteIdLabel: {
    '&&': {
      fontWeight: 400,
    },
  },
}));
